import DatePicker, { ReactDatePickerProps }         from 'react-datepicker'
import moment                                       from "moment";
import { useEffect, useState }                      from 'react';

import "react-datepicker/dist/react-datepicker.css";

const SelectPeriode = (props) => {

    const [time, setTime] = useState(new Date())

    useEffect(() => {
        if(props.periode_context != null && props.periode_context != "") {
            setTime(moment(props.periode_context).unix() * 1000)
        }
    }, [props])

    useEffect(() => {
        props.set_periode_context(moment(time).format("yyyy-MM"))
    }, [time])

    return (
        <DatePicker
            showMonthYearPicker
            selected={time}
            className="form-control"
            dateFormat='yyyy-MM'
            onChange={(date: Date) => setTime(date)}
        />
    )
}

export default SelectPeriode